// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"56472e2f","643":"8ad89e6f"}[chunkId] + ".chunk.js";
};